export default "__VITE_ASSET__Dmbl868___"